import React from "react";
import { useSubheader } from "../../../_metronic/layout";
import StudentFamilyFilterSearch from "./components/StudentFamilyFilterSearch";
import StudentFamilyBranchTable from "./components/StudentFamilyBranchTable";

export const StudentFamilyBranchList = () => {
  const suhbeader = useSubheader();
  suhbeader.setTitle("Add Student Family To Branch");

  return (
    <>
      <div className="card card-custom">
        <div className="card-header border-0 py-5">
          <h3 className="card-title align-items-start flex-column">
            <span className="card-label font-weight-bolder text-dark">
              Add Student Family To Branch Filters
            </span>
          </h3>
        </div>
        <div className="card-body">
          <StudentFamilyFilterSearch />
        </div>
      </div>
      <StudentFamilyBranchTable />
    </>
  );
};
